
(function ($) {
	$(function() {

		var carousel = $('#carousel');

		carousel.hammer().bind("swipeleft", function () {
			carousel.carousel('next');
		}).bind("swiperight", function () {
			carousel.carousel('prev');
		});

		// $('body').keydown(function(e) {
		// 	if(e.which == 37) {
		// 		carousel.carousel('prev');
		// 	} else if(e.which == 39) {
		// 		carousel.carousel('next');
		// 	} else if(e.which == 80) {
		// 		carousel.carousel('pause');
		// 	}
		// });

		/*
		$(".carousel-inner > .item > a").swipe({
			swipeLeft: function()  {
				console.log('next');
				$(this).closest('carousel').carousel('next');
			},
			swipeRight: function() {
				console.log('prev');
				$(this).closest('carousel').carousel('prev');
			},
			tap: function () {
				alert(123);
			},
			threshold: 0
		});
		*/

		carousel.on('slid.bs.carousel', function (event) {
			var current = $('.active', this).index('#carousel .item') + 1;
			$('.current').text(current);

			$('.item', '#carousel').attr('aria-hidden', 'true').filter('.active').attr('aria-hidden', 'false');
		});

		var carouselState = 'cycle';
		$('[data-carousel="pause"]', '#carousel').on('click', function (event) {
			event.preventDefault();

			if (carouselState == 'cycle') {
				carouselState = 'pause';
				$('.glyphicon', this).removeClass('glyphicon-pause').addClass('glyphicon-play');
			} else {
				carouselState = 'cycle';
				$('.glyphicon', this).removeClass('glyphicon-play').addClass('glyphicon-pause');
			}

			carousel.carousel(carouselState);
		});

	});
})(jQuery);